import React from 'react';
import PropTypes from 'prop-types';
import useStyles from './styles/SelectionBar.styles';

function SelectionBar({ selectedCount, onClearAll, onMigrate, migrating }) {
  const classes = useStyles();
  
  if (selectedCount === 0) return null;

  return (
    <div className={classes.bar}>
      <div className={classes.actions}>
        <button
          type="button"
          onClick={onClearAll}
          className={classes.clearButton}
        >
          Clear Selection
        </button>
        <button
          type="button"
          onClick={onMigrate}
          disabled={migrating}
          className={`${classes.migrateButton} ${migrating ? classes.migrateButtonDisabled : ''}`}
        >
          {migrating ? 'Migrating...' : `Migrate (${selectedCount})`}
        </button>
      </div>
    </div>
  );
}

SelectionBar.propTypes = {
  selectedCount: PropTypes.number,
  onClearAll: PropTypes.func,
  onMigrate: PropTypes.func,
  migrating: PropTypes.bool,
};

SelectionBar.defaultProps = {
  selectedCount: 0,
  onClearAll: undefined,
  onMigrate: undefined,
  migrating: false,
};

export default SelectionBar;
